import { GetterTree } from 'vuex'
import { AppState } from './types'
import { IS_LOADING, GET_USER_AGENT, TRANSLATE, DISABLED_SOCIAL, IS_PARTER } from './constant'
import translate from '@/language'

export const getters: GetterTree<AppState, unknown> = {
  [IS_LOADING]: state => state.isLoading,
  [TRANSLATE]: state => (name: string) => {
    let userAgent = state.userAgent

    // check default agent
    if (!userAgent) {
      const tmp = navigator.userAgent.match(/\w+/)
      if (tmp) {
        userAgent = tmp[0].toLowerCase()
      }
    }

    return translate(userAgent || '', name)
  },
  [GET_USER_AGENT]: state => state.userAgent,
  [IS_PARTER]: state => {
    return state.userAgent === 'sdk'
  },
  [DISABLED_SOCIAL]: state => {
    const params = new URLSearchParams(location.search)
    const socialDisabled = params.get('social_disabled')
    if (state.userAgent === 'sdk') {
      return true
    } else if (socialDisabled) {
      return socialDisabled === 'true'
    }

    return false
  }
}
